/**
 * Notification resolution
 */
export enum NotificationResolution {
    OPEN = 'open',
    DISMISSED = 'dismissed',
    COMPLETED = 'completed',
}
